import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async';
import App from './App.jsx'
import './index.css'
import { GamificationProvider } from './context/GamificationContext'
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary'

const rootElement = document.getElementById('root');

const AppTree = (
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <GamificationProvider>
              <CartProvider>
                <HelmetProvider>
                  <App />
                </HelmetProvider>
              </CartProvider>
            </GamificationProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// Support for hydration if content exists (for SEO)
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, AppTree);
} else {
  ReactDOM.createRoot(rootElement).render(AppTree);
}
